import { useAtomValue } from 'jotai'
import { loadable } from 'jotai/utils'
import { FC } from 'react'

import { filterState, selectedRyoikiLabels } from '../atoms/filterState'

export const RyoikiNenjiLabel: FC = () => {
  const labelsAtom = useAtomValue(loadable(selectedRyoikiLabels))
  const { nenjis } = useAtomValue(filterState)

  if (labelsAtom.state !== 'hasData') {
    return null
  }

  const labels = labelsAtom.data

  let message = ''
  if (labels.length === 0 || nenjis?.length === 0) {
    message = '領域と学年を選択してください'
  } else {
    message = `${labels.join(', ')} ${nenjis?.join(',')}年次`
  }

  document.title = message

  return <div>{message}</div>
}
